import BattleCard from 'components/Alerts/Modal/components/Bonuses/components/VipBonuses/components/BattleCard';
import SupportCard from 'components/Alerts/Modal/components/Bonuses/components/VipBonuses/components/SupportCard';
import { useHookFabric } from 'hooks/useHookFabric';
import {
  CommonOperationProperties,
  MixerTransactionResponse,
  TransactionFilterType,
} from 'react-memory-optimization/dist/lib/store/operations/types';
import { useHistoryTransactions } from 'react-render-hooks';

const range = [0, 0];

const CashBonuses = () => {
  const transactions = useHookFabric<MixerTransactionResponse>({
    fn: useHistoryTransactions,
    customProps: {
      range,
      types: [
        TransactionFilterType.EgtHistory,
        TransactionFilterType.ActiveTournament,
      ],
    },
  });

  return (
    <>
      {transactions?.map((t) => {
        if (t.additionalInfo.type === TransactionFilterType.EgtHistory) {
          return <SupportCard key={t.id} info={t.additionalInfo} id={t.id} />;
        }

        if (t.additionalInfo.type === TransactionFilterType.ActiveTournament) {
          return (
            <BattleCard
              key={t.id}
              info={t.additionalInfo}
              id={t.id}
              operation={t.operation as CommonOperationProperties}
            />
          );
        }

        return null;
      })}
    </>
  );
};

export default CashBonuses;
